import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

import { formatDate, formatNumber, formateDateToKorean } from 'shared/lib';
import printChkEmpty from 'styles/images/print-chk-empty.svg';
import printChkOn from 'styles/images/print-chk-on.svg';
import dsmc from 'styles/images/template-logo-dsmc.jpg';
import hallym from 'styles/images/template-logo-hallym.jpg';
import hyumcGuri from 'styles/images/template-logo-hyumc-guri.png';
import hyumcSeoul from 'styles/images/template-logo-hyumc-seoul.png';

// PDF 템플릿 내 name 값과 매칭 시켜 데이터 바인딩
export const USER_INFO_KEYS = [
  'usrNm',
  'usrBirthday',
  'usrAge',
  'ptNo',
  'hsptlzWard',
  'hsptlzRoom',
  'deptNm',
  'medrNm',
  'phoneNumberList',
  'postNo',
  'bscAddr',
  'dtlAddr',
  'usrRrn',
  'sex',
  'typeAssistance',
  'hsptlzDate',
  'advancedRoomFee',
  'insuranceType',
  'roomGrade',
  'consultationDate',
  'caregiverRelationship',
  'caregiverName',
  'caregiverBirthDate',
  'caregiverSex',
  'caregiverPhoneNumberList',
  'caregiverPostNumber',
  'caregiverAddress',
  'caregiverDetailAddress',
];

export const createPdf = async (pages, setConsentFile) => {
  const pdf = new jsPDF({
    unit: 'pt', // 'pt'는 포인트 단위, 1pt = 1/72 inch
    format: [595, 842], // A4 사이즈, 595x842 pt
  });
  for (let idx = 0; idx < pages.length; idx++) {
    try {
      const canvas = await html2canvas(pages[idx], {
        scale: 2,
      });
      const url = canvas.toDataURL('image/jpeg', 2);

      pdf.addImage(url, 'JPG', 0, 0, 595, 842);

      if (idx + 1 < pages.length) {
        pdf.addPage();
      }

      if (idx === pages.length - 1) {
        setConsentFile(pdf.output('dataurlstring'));
      }
    } catch (error) {
      alert(error);
    }
  }
};

export const bindTableData = (fileInfo) => {
  USER_INFO_KEYS.forEach((key) => {
    const elements = document.querySelectorAll(`[name=${key}]`);
    if (elements) {
      if (key === 'sex') {
        document
          .querySelectorAll(`[name=${key}]`)
          .forEach((el) => (el.textContent = fileInfo[key] === 'M' ? '남' : '여'));
      } else if (key === 'phoneNumberList' || key === 'caregiverPhoneNumberList') {
        elements.forEach((el, idx) => {
          const phoneNumber = fileInfo[key]?.[idx] || '-';
          el.textContent = phoneNumber ? phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3') : '-';
        });
      } else if (key === 'advancedRoomFee') {
        elements.forEach((el) => {
          el.textContent = `${formatNumber(fileInfo[key])}원`;
        });
      } else if (key === 'usrAge') {
        const y = parseInt(fileInfo.usrBirthday.slice(0, 4), 10);
        const m = parseInt(fileInfo.usrBirthday.slice(4, 6), 10);
        const d = parseInt(fileInfo.usrBirthday.slice(6, 8), 10);
        const today = new Date();
        let age = today.getFullYear() - y;

        if (today.getMonth() + 1 < m || (today.getMonth() + 1 === m && today.getDate() < d)) {
          age--;
        }
        document.querySelectorAll(`[name=${key}]`).forEach((el) => (el.textContent = age));
      } else if (
        key === 'hsptlzDate' ||
        key === 'usrBirthday' ||
        key === 'consultationDate' ||
        key === 'caregiverBirthDate'
      ) {
        document.querySelectorAll(`[name=${key}]`).forEach((el) => {
          el.textContent = fileInfo[key] ? `${formateDateToKorean(fileInfo[key])}` : '-';
        });
      } else {
        document.querySelectorAll(`[name=${key}]`).forEach((el) => (el.textContent = fileInfo[key] || '-'));
      }
    }
  });

  // 날짜 추가
  if (document.querySelector('[name=YYYYMMDD]')) {
    document.querySelector('[name=YYYYMMDD]').textContent = new Date().toLocaleString('ko-KR', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
    });
  }

  // 날짜 추가
  if (document.querySelector('[name=YYYYMMDD-HHMM]')) {
    document.querySelectorAll('[name=YYYYMMDD-HHMM]').forEach((el) => {
      el.textContent = new Date().toLocaleString('ko-KR', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: true,
      });
    });
  }
};

export const createNonBenefit = (nonBenefitList) => {
  if (nonBenefitList.length === 0) return;
  const BENEFIT_NAME = 'nonBenefitName';
  const nonBenefitWrap = document.querySelector(`[name=${BENEFIT_NAME}]`);
  const contentWrap = document.querySelector('.content-wrap');

  if (nonBenefitWrap && contentWrap) {
    // 모든 상세 항목을 플랫하게 만들어서 페이지별로 정확히 20개/30개씩 나누기
    const allDetailItems = [];
    nonBenefitList.forEach((benefit) => {
      allDetailItems.push({
        type: 'parent',
        benefitName: benefit[BENEFIT_NAME],
      });
      benefit.nonBenefitDetailList.forEach((detail) => {
        allDetailItems.push({
          type: 'child',
          benefitName: benefit[BENEFIT_NAME],
          detail: detail,
        });
      });
    });

    const allHTMLItems = [];
    const firstPageLimit = 20;
    const otherPageLimit = 26;
    let currentIndex = 0;

    while (currentIndex < allDetailItems.length) {
      const pageLimit = allHTMLItems.length === 0 ? firstPageLimit : otherPageLimit;
      const pageItems = allDetailItems.slice(currentIndex, currentIndex + pageLimit);

      const pageHTML = pageItems.map((item) => {
        if (item.type === 'parent') {
          return `
            <li class="item-tit">
              <h4>${item.benefitName}</h4>
            </li>
          `;
        }
        return `
          <li class="child-item">
            <div>
              <div class="tit">
                <span>[${item.detail.nonBenefitDetailCode}][비급여]${item.detail.nonBenefitDetailName}</span>
              </div>
              <div class="con">
                <span>${formatNumber(item.detail.nonBenefitDetailAmount)}원</span>
              </div>
            </div>
          </li>
        `;
      });

      if (pageHTML.length < pageLimit) {
        const emptyRows = pageLimit - pageHTML.length;
        for (let i = 0; i < emptyRows; i++) {
          pageHTML.push(`
             <li class="child-item">
            <div>
              <div class="tit">
                <span></span>
              </div>
              <div class="con">
                <span></span>
              </div>
            </div>
          </li>
            `);
        }
      }

      allHTMLItems.push({
        html: pageHTML.join(''),
      });

      currentIndex += pageLimit;
    }

    // while (currentIndex < allDetailItems.length) {
    //   const pageLimit = allHTMLItems.length === 0 ? firstPageLimit : otherPageLimit;
    //   const pageItems = allDetailItems.slice(currentIndex, currentIndex + pageLimit);

    //   // 같은 benefitName끼리 그룹화
    //   const groupedItems = {};
    //   pageItems.forEach((item) => {
    //     if (!groupedItems[item.benefitName]) {
    //       groupedItems[item.benefitName] = [];
    //     }
    //     groupedItems[item.benefitName].push(item.detail);
    //   });

    //   // 그룹화된 항목들을 HTML로 변환
    //   const pageHTML = Object.entries(groupedItems)
    //     .map(([benefitName, details]) => {
    //       const detailsHTML = details
    //         .map(
    //           (detail) => `
    //         <li>
    //           <div>
    //             <div class="tit">
    //               <span>${`[${detail.nonBenefitDetailCode}][비급여]${detail.nonBenefitDetailName}`}</span>
    //             </div>
    //             <div class="con">
    //               <span>${detail.nonBenefitDetailAmount}원</span>
    //             </div>
    //           </div>
    //         </li>`,
    //         )
    //         .join('');

    //       return `
    //       <li>
    //         <div class="item-tit">
    //           <h4>${benefitName}</h4>
    //         </div>
    //         <ul class="sub-item-list">
    //           ${detailsHTML}
    //         </ul>
    //       </li>`;
    //     })
    //     .join('');

    //   allHTMLItems.push({
    //     html: pageHTML,
    //     count: pageItems.length,
    //   });

    //   currentIndex += pageLimit;
    // }

    // 각 HTML 항목이 이미 정확한 페이지 크기로 만들어졌으므로 단순히 배열로 변환

    const pages = allHTMLItems.map((item) => [item.html]);

    // 첫 페이지는 nonBenefitWrap에 추가
    if (pages.length > 0) {
      nonBenefitWrap.innerHTML = pages[0].join('');
    }

    // 나머지 페이지는 contentWrap에 추가
    if (pages.length > 1) {
      const remainingPagesHTML = pages
        .slice(1)
        .map(
          (page) =>
            `<div class="pdf-page">
          <div class="list-info-area">
          <div class="top-title">
              <h3>비급여 항목 및 예상 비용</h3>
            </div>
          <ul name="${BENEFIT_NAME}">${page.join('')}</ul>
              </div>
              </div>`,
        )
        .join('');
      const lastPage = contentWrap.querySelector('[name="last-page"]');
      if (lastPage) {
        lastPage.insertAdjacentHTML('beforebegin', remainingPagesHTML);
      } else {
        contentWrap.insertAdjacentHTML('beforeend', remainingPagesHTML);
      }
    }
  }
};

// 이전에는 사인을 본인 / 부모 하나씩이었지만 현재는 동의 항목 별임
// 따라서 sign 데이터 객체에 분별을 위한 코드 값 추가가 필요하고, 템플릿에서도 코드값에대한 data 속성이 필요함.
export const bindSign = (sign) => {
  if (!sign) return;
  const signs = Object.entries(sign).map(([key, value]) => {
    return {
      element: document.querySelector(`[name="${key}"]`),
      src: value,
    };
  });
  const caregiverSigns = document.querySelectorAll('[name="caregiverSignFile"]');
  const style = `
      position: absolute;
      left: 0;
      width: 100px;
    `;
  if (signs) {
    signs.forEach((sign) => {
      const img = document.createElement('img');
      img.src = sign.src;
      img.style.cssText = style;
      sign.element.appendChild(img);
    });
  }

  if (caregiverSigns) {
    caregiverSigns.forEach((caregiverSign) => {
      const img = document.createElement('img');
      // img.src = caregiverSignFile.signFile;
      img.style.cssText = style;
      caregiverSign.appendChild(img);
    });
  }
};

export const bindContentDetail = (contentDetailData) => {
  Object.entries(contentDetailData).forEach(([code, { status, value, type }]) => {
    const element = document.querySelector(`[name="${code}"]`);

    if (!element) return;
    if (type === 'toggle') {
      const yn = element.querySelectorAll('button');

      // data-status에 따라 체크/언체크 분리 처리
      yn.forEach((btn) => {
        const btnStatus = btn.dataset.status;

        if (btnStatus === status) {
          // 체크 상태 - 선택된 버튼

          const checkedImg = document.createElement('img');
          checkedImg.src = printChkOn;
          btn.prepend(checkedImg);
        } else {
          // 언체크 상태 - 선택되지 않은 버튼

          const uncheckedImg = document.createElement('img');
          uncheckedImg.src = printChkEmpty;
          btn.prepend(uncheckedImg);
        }
      });
    }

    if (type === 'sign') {
      const img = document.createElement('img');
      img.src = value;
      element.appendChild(img);
    }
  });
};

export const createLogo = (pages) => {
  const HOSPITALS = {
    hallym: hallym,
    dsmc: dsmc,
    'hyumc-guri': hyumcGuri,
    hyumc: hyumcSeoul,
  };
  const classList = [...document.querySelector('.content-wrap').classList];
  const key = classList.filter((className) => Object.keys(HOSPITALS).includes(className))[0];
  const image = HOSPITALS[key];

  [...pages].map((page) => {
    const logo = document.createElement('img');
    logo.className = 'logo';
    logo.src = image;
    page.appendChild(logo);
  });
};

